import type { ContentPage } from "@/lib/content/types";

// CRM › Salesforce Automation › Lead Management (leaf).
export const leadManagement: ContentPage = {
  slug: "salesforce-automation/lead-management",
  template: "hrmsFeature",
  seo: {
    title: "Lead Management Software - Capture, Score & Convert Leads | GetBiz CRM",
    description:
      "Capture, score, and route leads automatically with GetBiz CRM lead management software. Never miss a hot lead and convert more with a smart, automated pipeline.",
    keywords: [
      "lead management software",
      "lead capture software",
      "lead scoring",
      "lead routing",
      "sales lead management",
      "CRM lead management",
      "lead nurturing software",
    ],
    ogImage: "/assets/data/seoimages/lead-management.webp",
  },
  leaf: {
    hero: {
      caption: "Lead Management",
      title: "Capture, Score & Convert More Leads, Automatically",
      description:
        "GetBiz CRM captures leads from every source, scores them by intent, and routes them to the right rep instantly — so your team always works the hottest opportunities first.",
      h1: "caption",
    },
    split: {
      title: "Turn Every Lead Into a Real Opportunity",
      bullets: [
        { title: "Omnichannel Capture", description: "Collect leads from web forms, email, chat, calls and social in one place." },
        { title: "Automatic Lead Scoring", description: "Rank leads by behaviour and fit so reps focus on the ready-to-buy." },
        { title: "Smart Assignment", description: "Auto-route leads to the right rep by territory, product or round-robin." },
        { title: "Nurture & Follow-up", description: "Trigger timely follow-ups so no lead ever goes cold." },
      ],
      image: "/assets/images/img/product/crm/lead-image-crm.webp",
      imageAlt: "GetBiz CRM lead management software",
    },
    cardsHeading: {
      title: "Works With the Rest of Salesforce Automation",
      description:
        "Lead Management connects to every other part of your GetBiz CRM sales workflow.",
    },
    cards: [
      { title: "Deal Management", href: "/crm-software/salesforce-automation/deal-management/", description: "Convert qualified leads into deals and track them across your pipeline.", image: "/assets/images/img/product/crm/deal-management-image-Photoroom.webp", imageAlt: "CRM deal management" },
      { title: "Contact Management", href: "/crm-software/salesforce-automation/contact-management/", description: "Keep a complete, up-to-date record of every contact and their history.", image: "/assets/images/img/product/crm/contact-management-image.webp", imageAlt: "CRM contact management" },
      { title: "Workflow Management", href: "/crm-software/salesforce-automation/workflow-management/", description: "Automate lead follow-ups and hand-offs with no-code workflow rules.", image: "/assets/images/img/product/crm/workflow-image.webp", imageAlt: "CRM workflow management" },
      { title: "Cadences", href: "/crm-software/salesforce-automation/cadences/", description: "Put new leads into multi-step outreach sequences automatically.", image: "/assets/images/img/product/crm/cadence-image-Photoroom.webp", imageAlt: "CRM sales cadences" },
    ],
    testimonials: {
      title: "Sales teams close more with GetBiz CRM",
      description: "See why growing businesses trust GetBiz to manage their leads.",
    },
    bookDemoTitle: "Stop losing leads. Start converting them.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "lead-management-best-practices, lead-nurturing-guide",
    metaKey: "lead-management",
  },
  sections: [],
};
